import { getTypeNodeForNode } from 'Services/WeaverUtils'
import { NodeMetadata } from './shared'
import DetailsContainer from './DetailsContainer'

export default (item, { nodeIsEditable = false } = {}) -> ({ children }) ->

  <DetailsContainer
    item={item}
    type={if item instanceof Weaver.Node then getTypeNodeForNode(item)}
    title={if item instanceof Weaver.Node then <NodeMetadata node={item} /> else item.label}
    nodeIsEditable={nodeIsEditable}
  >
    { children }
  </DetailsContainer>
